import type { VerifyT } from "@/types/zod/common";
import { Mail } from "lucide-react";
import Call from "../../../components/common/Call";
import OtpForm from "./OtpForm";

type MagicOrOtp = "magic" | "otp";

interface Props {
	email: string;
	resendFn: () => void;
	submitFn: (data: VerifyT) => void;
}

const MagicOrOtp = (props: Props) => {
	return (
		<>
			<Call words="Verify you Email" icon={<Mail size={32} />}>
				{`Please enter the code sent to ${props.email}.\n\nDon't forget to check your junk!`}
			</Call>
			<br />
			<OtpForm resendFn={props.resendFn} submitFn={props.submitFn} />
		</>
	);
};

export default MagicOrOtp;
